import { EMPTY_STRING } from '../../../../constants/common'
import { formatNumberWithSeparators } from '../../../../utils/number'
import { toListingFlatNumber } from '../../RentalPortalListing.utils'
import { getListingFlatFloorText } from '../RentalPortalListingFlatField.utils'

function getListingFlatRoomsFactText(roomCount, t) {
  return Number.isFinite(roomCount)
    ? t('RentalPortal.ListingFormFlatFactsRoomsKey', { count: roomCount })
    : null
}

function getListingFlatAreaFactText(area, t) {
  return Number.isFinite(area)
    ? `${formatNumberWithSeparators(area)} ${t('Common.AreaUnitKey')}`
    : null
}

export function getListingFlatFactsText({ flat, t }) {
  return flat
    ? [
        getListingFlatRoomsFactText(toListingFlatNumber(flat.room_count), t),
        getListingFlatAreaFactText(flat.area, t),
        getListingFlatFloorText({ floor: flat.floor, t }),
        flat.building?.address?.value,
      ]
        .filter(Boolean)
        .join(' · ')
    : EMPTY_STRING
}
